import React from 'react';

export default function BadTable() {
  return (
    <svg
      width='28'
      height='24'
      viewBox='0 0 28 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_2607_11161)'>
        <path
          d='M2 7C2 3.68629 4.68629 1 8 1H20C23.3137 1 26 3.68629 26 7V15C26 18.3137 23.3137 21 20 21H8C4.68629 21 2 18.3137 2 15V7Z'
          fill='#27272A'
        />
        <path
          d='M17 8L11 14M11 8L17 14'
          stroke='#A1A1AA'
          stroke-width='1.25'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_2607_11161'
          x='0'
          y='0'
          width='28'
          height='24'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_2607_11161'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_2607_11161'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
}
